/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { TableView } from "@src/app/model/sys/nav-item";
import { TeamUserPageComponent } from "@src/app/modules/user/team-user-page/team-user-page.component";
import { NavRoute } from "@src/app/shared/NavRoute";

export const TeamUserPageNavRoute = new NavRoute('tusers', ()=>TeamUserPageComponent, 'people_alt').setViews(() => [
    {
        id: 'nonUnit',
        name: 'Non Unit Related',
        helpText: 'Users who have special privileges in the OMC - e.g. Directors, Agents, Accountants',
        filterFields: {
            unitName: 'null',
            roleId: 'All',
            current: 1,
        },
    },
    {
        id: 'currentMembers',
        name: 'Current Members',
        helpText: 'Current unit owners and members',
        filterFields: {
            unitName: 'not null',
            roleId: 'All',
            current: 1,
            isOwner: 1,
        },
    },
    {
        id: 'unitRelated',
        name: 'All Unit Related Roles',
        helpText: 'All current users with roles linked to a unit (Owners, Owner Occupiers, Residents etc)',
        filterFields: {
            unitName: 'not null',
            roleId: 'All',
            current: 1,
        },
    },
    {
        id: 'noEmailAvailable',
        name: 'Current members with no email address',
        helpText: 'Unit-linked contacts with no email address',
        filterFields: {
            unitName: 'not null',
            email: 'null',
            roleId: 'All',
            current: 1,
            isOwner: 1,
        },
    },
    {
        id: 'users_logged_in',
        name: 'All Users Who Have Logged In (Unit Related)',
        helpText: 'Unit-linked contacts who have logged in',
        filterFields: {
            userName: 'not null',
            unitName: 'not null',
            roleId: 'All',
            lastLoginAt: 'NOT NULL',
            current: 1,
        },
        sortDesc: 'lastLoginAt'
    },
    {
        id: 'users',
        name: 'All Registered Users (logged in or email received)',
        helpText: 'All registered users (logged in or email received)',
        filterFields: {
            userName: 'not null',
            roleId: 'All',
            current: 1,
        },
    },
    {
        id: 'nonUsers',
        name: 'Profiles Never Registered',
        helpText: 'Contacts who have never logged in or emailed the OMC',
        filterFields: {
            userName: 'null',
            current: 1,
        },
    },
] as TableView[]);
